module.exports = __webpack_public_path__ + "static/media/explore_01.8e580aaa.jpg";